import React, { useState, useEffect } from "react";
import { Panel, Loader, Table } from "rsuite";
import axios from "../../../utilities/axios";
import { MethodsUtils } from "../../../core/utils/MethodsUtils";

const { Column, HeaderCell, Cell } = Table as any

type Props = {
    channels: string[];
    periods: any;
    searchTrigger: number;
}

interface SortData {
    sortColumn?: string;
    sortType?: 'asc' | 'desc';
}

const AverageTicketByChannelPanel: React.FC<Props> = ({ channels, periods, searchTrigger }) => {
    const [rows, setRows] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [sortData, setSortData] = useState<SortData>({})

    const updateTable = () => {
        setLoading(true)
        setTimeout(() => setLoading(false), 100)
    }

    const fetchData = async () => {
        setLoading(true)
        try {
            const { data } = await axios.post('/api/v1/analytics/sales/average_ticket_by_channel', { channels, periods })
            setRows(Array.isArray(data) ? data : [])
        } catch (err) {
            console.error(err)
            setRows([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (searchTrigger > 0) {
            fetchData()
        }
    }, [searchTrigger])

    const handleSortColumn = (sortColumn: string, sortType?: 'asc' | 'desc') => {
        setSortData({ sortColumn, sortType })
        const sorted = [...rows].sort((a, b) => {
            const aVal = a[sortColumn]
            const bVal = b[sortColumn]
            if (typeof aVal === 'string') {
                return sortType === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
            }
            return sortType === 'asc' ? aVal - bVal : bVal - aVal
        })
        setRows(sorted)
    }

    return (
        <Panel onEnter={updateTable} bordered header={<strong>Ticket Médio por Canal</strong>} style={{ background: 'white', borderColor: 'rgb(255, 140, 66)' }} collapsible>

            {loading ? (
                <div style={{ padding: 24, display: 'flex', justifyContent: 'center' }}><Loader content="Carregando..." /></div>
            ) : rows.length === 0 ? (
                <div style={{ padding: 16 }}>Nenhum dado</div>
            ) : (
                <Table key={rows.length} data={rows} sortColumn={sortData.sortColumn} sortType={sortData.sortType} onSortColumn={handleSortColumn} autoHeight>
                    <Column width={300} sortable>
                        <HeaderCell>CANAL</HeaderCell>
                        <Cell dataKey="canal" />
                    </Column>
                    <Column width={150} align="right" sortable>
                        <HeaderCell>PERIODO A</HeaderCell>
                        <Cell dataKey="periodo_a">
                            {(rowData: any) => MethodsUtils.formatCurrency(rowData.periodo_a)}
                        </Cell>
                    </Column>
                    <Column width={150} align="right" sortable>
                        <HeaderCell>PERIODO B</HeaderCell>
                        <Cell dataKey="periodo_b">
                            {(rowData: any) => MethodsUtils.formatCurrency(rowData.periodo_b)}
                        </Cell>
                    </Column>
                    <Column width={150} align="right" sortable>
                        <HeaderCell>VARIAÇÃO %</HeaderCell>
                        <Cell dataKey="variacao_percentual">
                            {(rowData: any) => MethodsUtils.formatPercentual(rowData.variacao_percentual, { signDisplay: "always" })}
                        </Cell>
                    </Column>
                </Table>
            )}
        </Panel>
    )
}

export default AverageTicketByChannelPanel
